module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/img_gifu-66dcaa2afb1d9f5c1a9d34b3f7d85292.png";